export default {"src":"/_next/static/media/instagram.0161d7c8.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};